import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance";

export const realtorWebcardApi = createAsyncThunk(
  "realtorWebcard/fetchProfile",
  async (realtorCode, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/auth/webcard/${realtorCode}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const realtorSubscriptionApi = createAsyncThunk(
  "realtorsubscription/createrealtorsubscription",
  async ({ user_id, community_id, product_id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "payment/create-subscription/",
        {
          user_id,
          community_id,
          product_id,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const realtorFetchSubscriptionApi = createAsyncThunk(
  "realtorWebcard/fetchProfile",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/payment/create-subscription",
        {
          params: {
            user_id: userId,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const realtorCancelSubscriptionApi = createAsyncThunk(
  "cancelsubscription/realtorCancelSubscription",
  async ({ user_id, subscription_id, community_id, record_id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "payment/realtor-subscription-cancel",
        {
          user_id,
          subscription_id,
          community_id,
          record_id
        }
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return []; // Return an empty array instead of rejecting
      }
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateRealtorAdBanner = createAsyncThunk(
  "community/updateRealtorAdBanner",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        "/community/update-realtor-ad-banner/",
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);